import React from 'react';
import { Sequence, AbsoluteFill, Audio, staticFile, useVideoConfig, useCurrentFrame } from 'remotion';
import { CinematicTheme } from '../components/cinematic/theme';
import { AnimatedGradientBackground } from '../components/cinematic/backgrounds/AnimatedGradientBackground';
import { BlurReveal } from '../components/cinematic/typography/BlurReveal';
import { SplitText } from '../components/cinematic/typography/SplitText';
import { CinematicCaptions } from '../components/cinematic/typography/CinematicCaptions';
import reelData from '../../public/reel-data.json';
import { ReelMetadata } from '../types';

const data = reelData as ReelMetadata;

export const PlaybookDemo: React.FC = () => {
  const { fps } = useVideoConfig();
  const frame = useCurrentFrame();
  const introFrames = Math.ceil((data.introDurationMs / 1000) * fps);
  return (
    <AbsoluteFill style={{ backgroundColor: CinematicTheme.colors.background }}>
      <AnimatedGradientBackground />
      <Audio src={staticFile("voice.wav")} volume={1.2} />
      
      <AbsoluteFill style={{ justifyContent: 'center', alignItems: 'center', padding: '60px' }}>
        
        {/* Sequence 1: Intro Headline */}
        <Sequence  durationInFrames={introFrames}>
          <AbsoluteFill style={{ justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
            <div style={{ ...CinematicTheme.typography.hero, fontSize: 64, color: CinematicTheme.colors.typography }}>
              <SplitText text={data.headline} type="words" delay={10} staggerFrames={3} />
            </div>
          </AbsoluteFill>
        </Sequence>

        {/* Sequence 2: Subtitles (Voice Script) */}
        <Sequence from={introFrames}>
          <AbsoluteFill style={{ justifyContent: 'center', alignItems: 'center' }}>
            <CinematicCaptions subtitles={data.subtitles} />
          </AbsoluteFill>
        </Sequence>

      </AbsoluteFill>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
